module.exports = __webpack_public_path__ + "static/img/darkBg.4d65ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/dark/darkBg.png
// module id = 27ia
// module chunks = 2